import React, { useContext, useEffect, useMemo } from 'react';
import { ClientContext } from '../../Contexts/contexts';
import { stateProgression } from '../../../data/statusDefinitions';
import { quoteStatus } from '../../../data/quoteStatus';

function State() {
  const clientContext = useContext(ClientContext);

  const getProgress = useMemo(() => {
    if (
      [1].includes(clientContext?.clientExpertRelation?.clientSigned) &&
      clientContext.clientExpertRelation.status ===
        quoteStatus.appointmentAchieved
    )
      return clientContext.clientExpertRelation.status + 2;

    return !clientContext?.clientExpertRelation
      ? 0
      : clientContext.clientExpertRelation.status + 1;
  }, [clientContext.clientExpertRelation]);

  useEffect(() => {
    increaseProgress(
      'fill-user',
      parseFloat(
        (getProgress / (Object.keys(quoteStatus).length - 2)) * 100
      ).toFixed(0)
    );
    //increaseProgress('fill-expert', progressNumber2);
  }, [getProgress]);

  function increaseProgress(id, progressPourcent) {
    let elm = document.getElementById(id);

    if (elm) {
      if (progressPourcent > 100) {
        progressPourcent = 100;
      }

      if (progressPourcent < 33) {
        elm.style.backgroundColor = '#F2BD41';
      } else if (progressPourcent >= 33 && progressPourcent < 66) {
        elm.style.backgroundColor = '#84bf82';
      } else if (progressPourcent >= 66 && progressPourcent <= 100) {
        elm.style.backgroundColor = '#3ac1ae';
      }

      elm.style.width = progressPourcent + '%';
    } else {
      console.error("L'élément avec l'ID " + id + " n'a pas été trouvé.");
    }
  }

  return (
    <>
      <div className="state-container">
        <div className="title">État d'avancement</div>
        <div>
          <div className="progress-title-number-container">
            <div className="progress-bar-title">
              {stateProgression[getProgress]}
            </div>
            <div className="progress-bar-number">
              {parseFloat(
                (getProgress / (Object.keys(quoteStatus).length - 2)) * 100
              ).toFixed(0) + '%'}
            </div>
          </div>
          <div className="state-container-progress">
            <div className="progress-bar-steps">
              <div className="progress-fill" id="fill-user"></div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default State;
